import React__default from 'react';
import { ToastContainer, IconContainer, Caption } from './styles.js';
import { ReactComponent as SvgCheckIcon } from '../../../assets/icons/check-icon.svg.js';
import InfoIcon from '@mui/icons-material/Info';
import { ReactComponent as SvgErrorAlertIcon } from '../../../assets/icons/error-alert-icon.svg.js';
import { useTheme, Typography } from '@mui/material';

var Toaster = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "error" : _b, _c = _a.size, size = _c === void 0 ? "large" : _c, _d = _a.caption, caption = _d === void 0 ? "" : _d, id = _a.id;
    var palette = useTheme().palette;
    return (React__default.createElement(ToastContainer, { variant: variant, size: size, id: id },
        React__default.createElement(IconContainer, { size: size },
            variant === "error" && React__default.createElement(SvgErrorAlertIcon, { color: palette.red }),
            variant === "success" && React__default.createElement(SvgCheckIcon, { color: palette.green }),
            variant === "info" && React__default.createElement(InfoIcon, { fill: palette.neutral600 })),
        React__default.createElement(Caption, { variant: variant },
            React__default.createElement(Typography, { variant: size === "large" ? "body1" : "body2", color: { error: "red", success: "green" }[variant], fontWeight: "regular" }, caption))));
};

export { Toaster as default };
